// ============================================================================
// ROSTER DE LA FIRMA
//
// Vive aquí y no dentro del JSX porque es el único dato del sitio que cambia
// por motivos de NEGOCIO y no de diseño: entra alguien, sale alguien, cambia
// una URL de LinkedIn. Nadie debería abrir un componente de 200 líneas de
// Tailwind para dar de alta a un socio.
//
//   slug  -> nombre del archivo en public/assets/team/<slug>.jpg
//   hd    -> la foto original aguanta un @2x REAL, sin ampliar de más.
//            Si es false NO se emite srcSet y el navegador escala el 1x:
//            mismo desenfoque, cero bytes desperdiciados.
//   photo -> false cuando no existe retrato. Se pinta el monograma.
//   size  -> ancho de la tarjeta en px. Es la jerarquía del bloque y a la vez
//            el techo de publicación honesto de cada foto: Carlos (206px de
//            origen) se renderiza a 200 y por tanto casi a resolución nativa.
// ============================================================================
export const TEAM_GROUPS = [
  {
    label: 'Socios',
    role: 'Socio',
    size: 300,
    members: [
      { slug: 'fernando', name: 'Fernando Todd', hd: true, linkedin: 'https://www.linkedin.com/in/fernandotodd/' },
      { slug: 'teresa', name: 'Teresa Sada', hd: true, linkedin: 'https://www.linkedin.com/in/teresa-sada-032436170/' },
      { slug: 'mercy', name: 'Mercy Muñoz', hd: true, linkedin: 'https://www.linkedin.com/in/mercy-mu%C3%B1oz-7035bb54/' },
    ],
  },
  // {
  //   label: 'Of Counsels',
  //   role: 'Of Counsel',
  //   size: 200,
  //   members: [
  //     // 333x333 de origen: el @2x sale de una ampliación de 1.33x, dentro del
  //     // techo de 1.7x por encima del cual un rostro empieza a verse blando.
  //     { slug: 'antonio', name: 'Antonio Dieck', hd: true, linkedin: 'https://www.linkedin.com/in/antoniojdieck/' },
  //     // 206x206: no hay material para un @2x honesto. Va solo a 1x.
  //     { slug: 'carlos', name: 'Carlos Aldape', hd: false, linkedin: 'https://www.linkedin.com/in/carlos-a-79a6a810/' },
  //   ],
  // },
  {
    label: 'Equipo',
    role: 'Equipo',
    size: 200,
    members: [
      { slug: 'vanessa', name: 'Vanessa del Río', hd: true, linkedin: 'https://www.linkedin.com/in/vanessa-del-rio-2665a6247/' },
      { slug: 'karen', name: 'Karen Barroso', hd: true, linkedin: 'https://www.linkedin.com/in/karen-barroso-37a5b0249/' },
    ],
  },
];

// Iniciales para quien no tiene retrato. Descarta las partículas ("de", "del",
// "la"): van en minúscula y no aportan a la abreviatura.
// "Vanessa del Río" -> "VR"
export const iniciales = (nombre) =>
  nombre
    .split(' ')
    .filter((p) => /^[A-ZÁÉÍÓÚÑ]/.test(p))
    .slice(0, 2)
    .map((p) => p[0])
    .join('');
